const sendEvent = (category, action, label) => {
  if (typeof sendGoogleAnalyticsEvents === "function")
    window.sendGoogleAnalyticsEvents(category, action, label);
};

export { sendEvent };
